import { WalkI } from './../../interfaces/Walk';
import { OPEN_PREVIEW, CLOSE_PREVIEW } from '../constants/index'

export const openPreview = (payload: WalkI) => {
  return {
    type: OPEN_PREVIEW,
    payload
  }
}

export const closePreview = (payload: WalkI) => {
  return {
    type: CLOSE_PREVIEW,
    payload
  }
}

